'use client'

import React from 'react'

import styles from './styles.module.scss'
import { If, Loader } from '..'

const Button = ({
  children,
  variant = 'primary',
  textVariant = 'primary',
  className = '',
  size = 'small',
  outline = false,
  sendtoform = false,
  isLoading,
  ...props
}) => {
  const CustomTag = props.href ? 'a' : 'button'

  const outlineClass = outline ? styles.outline : ''
  const buttonClasses = `${styles.button} ${styles[variant]} ${styles[`text--${textVariant}`]}
   ${styles[size]} ${isLoading ? styles.loading : ''} ${outlineClass} ${className}`

  return (
    <CustomTag className={buttonClasses} {...props}>
      <If condition={isLoading} renderIf={<Loader />} renderElse={children} />
    </CustomTag>
  )
}

export default Button
